import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
  FieldType,
  FieldTypeConfig,
  FormlyFieldConfig,
  FormlyModule,
} from '@ngx-formly/core';
import {
  FormlyFieldSelectProps,
  FormlySelectModule,
} from '@ngx-formly/core/select';
import { FormlyFieldProps } from '@ngx-formly/primeng/form-field';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';

interface MultiselectProps extends FormlyFieldProps, FormlyFieldSelectProps {
  selectionLimit?: number;
  showToggleAll?: boolean;
}

export interface FormlyMultiselectFieldConfig
  extends FormlyFieldConfig<MultiselectProps> {}

@Component({
    selector: 'kon-multiselect-type',
    imports: [
        CommonModule,
        FormlyModule,
        MultiSelectModule,
        FormlySelectModule,
        ReactiveFormsModule,
        InputTextModule,
    ],
    template: `
    <p-multiSelect
      #multiselect
      [id]="id"
      [appendTo]="'body'"
      [options]="(props.options | formlySelectOptions: field | async) ?? []"
      [optionLabel]="'label'"
      [optionValue]="'value'"
      [formControl]="formControl"
      [showClear]="!props.required"
      (onChange)="props.change && props.change(field, $event)"
      [virtualScroll]="true"
      [filter]="true"
      [virtualScrollItemSize]="42"
      [style]="{ width: '100%' }"
      [selectionLimit]="props.selectionLimit"
      [placeholder]="props.placeholder"
      [showToggleAll]="props.showToggleAll"
    >
    </p-multiSelect>
  `,
    styles: [],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormlyMultiselectTypeComponent extends FieldType<
  FieldTypeConfig<MultiselectProps>
> {}
